var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cancel",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.076,
    height: 30.076,
    viewBox: "0 0 30.076 30.076",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11357",
    "data-name": "Path 11357",
    d: "M37.421,836.7V834.7H16.368V836.7a2,2,0,0,0,2.005,2.005H39.427a2.005,2.005,0,0,1-2.005-2.005Zm0,0",
    transform: "translate(-15.867 -809.134)",
    fill: "#66a7f6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11358",
    "data-name": "Path 11358",
    d: "M147.3,755.373h17.043v2.005a2.005,2.005,0,0,0,4.01,0v-4.511H147.3Zm0,0",
    transform: "translate(-142.79 -729.808)",
    fill: "#99c5f9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11359",
    "data-name": "Path 11359",
    d: "M170.36,16.367H149.306a2,2,0,0,0-2.005,2.005v4.511h21.053V18.372A2.005,2.005,0,0,1,170.36,16.367Zm0,0",
    transform: "translate(-142.79 -15.866)",
    fill: "#99c5f9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11360",
    "data-name": "Path 11360",
    d: "M836.7,16.367a2.005,2.005,0,0,0-2.005,2.005v2.005h4.01V18.372A2.005,2.005,0,0,0,836.7,16.367Zm0,0",
    transform: "translate(-809.134 -15.866)",
    fill: "#66a7f6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11361",
    "data-name": "Path 11361",
    d: "M17.37,229.133a1,1,0,0,0-1,1v14.036a1,1,0,0,0,1,1H44.438a1,1,0,0,0,1-1V230.136a1,1,0,0,0-1-1ZM30.9,231.138a6.015,6.015,0,1,1-6.015,6.015A6.015,6.015,0,0,1,30.9,231.138Zm-10.527,1",
    transform: "translate(-15.866 -222.115)",
    fill: "#ffc170"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11362",
    "data-name": "Path 11362",
    d: "M300.617,306.632a6.015,6.015,0,1,0-6.015-6.015A6.015,6.015,0,0,0,300.617,306.632Zm-3.008-9.023,3.008,3.008,3.008-3.008-3.008,3.008,3.008,3.008-3.008-3.008-3.008,3.008,3.008-3.008Zm0,0",
    transform: "translate(-285.579 -285.579)",
    fill: "#66a7f6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11363",
    "data-name": "Path 11363",
    d: "M29.576,5.013a.5.5,0,0,0,.5-.5V2.506A2.509,2.509,0,0,0,27.571,0H6.517A2.509,2.509,0,0,0,4.011,2.506v4.01H1.5A1.5,1.5,0,0,0,0,8.02V22.056a1.5,1.5,0,0,0,1.5,1.5H4.011v1.5H.5a.5.5,0,0,0-.5.5V27.57a2.509,2.509,0,0,0,2.506,2.506H23.561a2.509,2.509,0,0,0,2.506-2.506V23.56h2.506a1.5,1.5,0,0,0,1.5-1.5V8.02a1.5,1.5,0,0,0-1.5-1.5H26.067v-1.5Zm-.5-2.506v1.5H26.067v-1.5a1.5,1.5,0,0,1,3.008,0ZM2.507,29.074A1.5,1.5,0,0,1,1,27.57v-1.5H21.054v1.5a2.48,2.48,0,0,0,.514,1.5Zm22.557-1.5a1.5,1.5,0,0,1-3.008,0V25.565a.5.5,0,0,0-.5-.5H5.013v-1.5H25.064Zm4.01-19.55V22.056a.5.5,0,0,1-.5.5H1.5a.5.5,0,0,1-.5-.5V8.02a.5.5,0,0,1,.5-.5H28.573A.5.5,0,0,1,29.074,8.02ZM5.013,6.516V2.506A1.5,1.5,0,0,1,6.517,1H25.579a2.48,2.48,0,0,0-.514,1.5v4.01Zm0,0",
    transform: "translate(-0.001 0)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11364",
    "data-name": "Path 11364",
    d: "M284.751,291.267a6.516,6.516,0,1,0-6.517-6.516A6.516,6.516,0,0,0,284.751,291.267Zm0-12.031a5.514,5.514,0,1,1-5.514,5.514A5.514,5.514,0,0,1,284.751,279.236Zm0,0",
    transform: "translate(-269.712 -269.712)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11365",
    "data-name": "Path 11365",
    d: "M381.939,387.955l2.653-2.653,2.653,2.653.709-.709-2.653-2.653,2.653-2.653-.709-.709-2.653,2.653-2.653-2.653-.709.709,2.653,2.653-2.653,2.653Zm0,0",
    transform: "translate(-369.554 -369.555)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11366",
    "data-name": "Path 11366",
    d: "M98.2,310.965h1v1h-1Zm0,0",
    transform: "translate(-95.192 -301.441)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11367",
    "data-name": "Path 11367",
    d: "M147.3,310.965h3.008v1H147.3Zm0,0",
    transform: "translate(-142.79 -301.441)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11368",
    "data-name": "Path 11368",
    d: "M98.2,360.066h1v1h-1Zm0,0",
    transform: "translate(-95.192 -349.038)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11369",
    "data-name": "Path 11369",
    d: "M147.3,360.066h3.008v1H147.3Zm0,0",
    transform: "translate(-142.79 -349.038)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11370",
    "data-name": "Path 11370",
    d: "M736.5,589.2h1v1h-1Zm0,0",
    transform: "translate(-713.943 -571.153)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11371",
    "data-name": "Path 11371",
    d: "M785.6,589.2h3.008v1H785.6Zm0,0",
    transform: "translate(-761.541 -571.153)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11372",
    "data-name": "Path 11372",
    d: "M736.5,638.3h1v1h-1Zm0,0",
    transform: "translate(-713.943 -618.752)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11373",
    "data-name": "Path 11373",
    d: "M785.6,638.3h3.008v1H785.6Zm0,0",
    transform: "translate(-761.541 -618.752)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.3dfa82d879082bc607ae91be0d63e8b2.svg";
export { ForwardRef as ReactComponent };